import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
import { format } from 'date-fns';

import { CalendarDay } from './calendar-day.interface';

@Injectable()
export class CalendarDateAdapter extends NativeDateAdapter {
  private firstDayOfWeek: CalendarDay = CalendarDay.Monday;

  override getFirstDayOfWeek(): number {
    return this.firstDayOfWeek;
  }

  setFirstDayOfWeek(day: CalendarDay): void {
    this.firstDayOfWeek = day;
  }

  override format(date: Date, displayFormat: string): string {
    return format(date, displayFormat);
  }
}
